import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import "./ChatActionBar.scss";

import { KnowledgeBaseSelection } from "./KnowledgeBaseSelection/KnowledgeBaseSelection";

const RawChatActionBar: FunctionComponent = () => {
  return (
    <div className="chat-action-bar">
      <KnowledgeBaseSelection />
    </div>
  );
};

export const ChatActionBar = observer(RawChatActionBar);
